import { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import { Swiper, SwiperSlide } from 'swiper/react';
import Plan, { PlanType } from 'models/Plan';
import AddOns from './AddOns';

type Props = {
    selectedPlanGiven : Plan
}

function AddOnTiles(selectedPlanGiven: Props): ReactElement {
  const seed = useUIDSeed();
    type AddOns = {
        plan: string,
        mealType: string,
        servingSize: string,
        pricePerServing: string,
        imageKey: string,
        maxQuantity: number,
    }
    const addOnData: AddOns[] = [];
    const { selectedPlanGiven: currentPlan } = selectedPlanGiven;
    if (!currentPlan.isDiversified && currentPlan.type === PlanType.MEAL_KIT) {
      addOnData.push({
        plan: 'Meal Kit',
        mealType: 'Breakfast',
        servingSize: '4',
        pricePerServing: '4.50',
        imageKey: 'extra-breakfast',
        maxQuantity: 2,
      },
      {
        plan: 'Meal Kit',
        mealType: 'Lunch',
        servingSize: '2',
        pricePerServing: '9',
        imageKey: 'extra-lunch',
        maxQuantity: 2,
      }, {
        plan: 'Meal Kit',
        mealType: 'Dinner',
        servingSize: '2',
        pricePerServing: '13.25',
        imageKey: 'extra-dinner',
        maxQuantity: 3,
      });
    } else if (!currentPlan?.isDiversified && (currentPlan?.type === PlanType.PREPARED
        || currentPlan?.type === PlanType.PROGRAMS)) {
      addOnData.push({
        plan: 'Ready to Eat',
        mealType: 'Dinner',
        servingSize: '1',
        pricePerServing: '',
        imageKey: 'ready-to-eat',
        maxQuantity: 10,
      });
    }

    return (
      <div className="c-my-account__add-ons__padding">
        <div className="c-my-account__add-ons__container">
          <div className="c-form-group c-recipe-gallery">
            <div className="c-my-account__add-ons__slider-container">
              <Swiper
                spaceBetween={12}
                className="c-my-account__add-ons__slider"
              >
                {addOnData.map((item, i) => (
                  <SwiperSlide key={seed(i)} className="c-my-account__add-ons__slide">
                    <AddOns
                      planData={currentPlan}
                      plan={item.plan}
                      mealType={item.mealType}
                      servingSize={item.servingSize}
                      pricePerServing={item.pricePerServing ?? ''}
                      imageKey={item.imageKey}
                      maxQuantity={item.maxQuantity}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    );
}

export default AddOnTiles;
